import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { Flex } from '@finect/tabular-core/Flex';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { H1 } from '@finect/tabular-core/Headings';
export var Page = styled(Flex).withConfig({
  displayName: "Page",
  componentId: "sc-1v2awh7-0"
})(["align-items:flex-start;flex-flow:column;flex-wrap:wrap;justify-content:space-between;", ";"], minMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    align-items: center;\n    flex-flow: row;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    margin-bottom: 0;\n  "]))));
export var PageTitle = styled(H1).withConfig({
  displayName: "Page__PageTitle",
  componentId: "sc-1v2awh7-1"
})(["display:block;flex-grow:1;padding-bottom:0;margin-bottom:14px;&:not(:last-child){padding-bottom:0;}", ";"], minMediaQueries.tablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex-wrap: nowrap;\n    margin-bottom: 14px;\n  "]))));